import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M14.232 2.184C12.788.728 10.894 0 9 0S5.212.728 3.767 2.184c-2.89 2.912-2.89 7.633 0 10.544L9 18l5.232-5.272c2.89-2.912 2.89-7.633 0-10.544zm-.851 9.699L9 16.297l-4.381-4.414c-2.423-2.441-2.423-6.413 0-8.854A6.13 6.13 0 0 1 9 1.2c1.654 0 3.21.649 4.381 1.829 2.422 2.441 2.422 6.413 0 8.854zM9 3.4c-2.261 0-4.1 1.839-4.1 4.1s1.839 4.1 4.1 4.1 4.1-1.839 4.1-4.1S11.261 3.4 9 3.4zm0 7c-1.599 0-2.9-1.302-2.9-2.9S7.401 4.6 9 4.6s2.9 1.302 2.9 2.9-1.301 2.9-2.9 2.9z" />
  </svg>
);

export default SvgComponent;
